import React from "react";
import { Cross1Icon } from "@radix-ui/react-icons";

interface SuccessMessageProps {
  message: string;
  onClose: () => void;
  className?: string;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message,
  onClose,
  className = "",
}) => {
  return (
    <div
      className={`p-3 bg-green-50 border border-green-200 text-green-700 rounded-none flex items-center justify-between ${className}`}
    >
      <span className="flex-1">{message}</span>
      <button
        onClick={onClose}
        className="ml-3 text-green-700 hover:text-green-900 transition-colors flex-shrink-0"
        aria-label="Close message"
      >
        <Cross1Icon className="h-4 w-4" />
      </button>
    </div>
  );
};
